import script from "./AdminShell.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminShell.vue?vue&type=script&setup=true&lang=js"

import "./AdminShell.vue?vue&type=style&index=0&id=afa7e4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa7e4a0"]])

export default __exports__